import { render } from "./Form2.vue?vue&type=template&id=ed46c63e&scoped=true"
import script from "./Form2.vue?vue&type=script&lang=js"
export * from "./Form2.vue?vue&type=script&lang=js"

import "../assets/css/main.css?vue&type=style&index=0&id=ed46c63e&scoped=true&lang=css"
import "./Form2.vue?vue&type=style&index=1&id=ed46c63e&scoped=true&lang=css"

import exportComponent from "D:\\archive\\my8\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed46c63e"]])

export default __exports__